export default {
    computed: {
        payoutSpeed() {
            return this.model.paymentAdministrationSpeed;
        },
        payoutDate() {
            return this.payoutSpeed?.date;
        },
        payoutDateDayString() {
            const now = new Date();
            const payout = this.payoutDate;
            if (!(payout instanceof Date) || isNaN(payout)) {
                return '';
            }
            const dayInMilliseconds = 86400000;
            const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const startOfPayout = new Date(payout.getFullYear(), payout.getMonth(), payout.getDate());
            const diffDays = Math.round((startOfPayout - startOfToday) / dayInMilliseconds);
            // this may need improving as now, for example, if it is a monday it might show wednesday 12.30, 
            // but unclear if it is wednesday in 2 days or next week(9 days from now) etc.
            if (diffDays === 0) return this.$translate('today', 'Idag');
            if (diffDays === 1) return this.$translate('tomorrow', 'Imorgon');

            return [
                this.$translate('sunday', 'Söndag'),
                this.$translate('monday', 'Måndag'),
                this.$translate('tuesday', 'Tisdag'),
                this.$translate('wednesday', 'Onsdag'),
                this.$translate('thursday', 'Torsdag'),
                this.$translate('friday', 'Fredag'),
                this.$translate('saturday', 'Lördag')
            ][startOfPayout.getDay()];
        },
        payoutDateTimeString() {
            const payout = this.payoutDate;
            if (!(payout instanceof Date) || isNaN(payout)) {
                return '';
            }
            return payout.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
        },
        payoutDateDayTimeString() {
            return `${this.payoutDateDayString} ${this.payoutDateTimeString}`;
        },
        payoutEta() {
            return this.payoutSpeed.eta;
        },
        payoutSpeedString() {

            let hours = 0;
            if (this.payoutEta.days) {
                hours += this.payoutEta.days * 24;
            }
            if (this.payoutEta.hours) {
                hours += this.payoutEta.hours;
            }

            if (hours > 0) {
                return `${hours} ${this.$translate('hours', 'timmar')}`;
            }
            return `${this.payoutEta.minutes} ${this.$translate('minutes', 'minuter')}`;
        }
    }
};